module.exports = __webpack_public_path__ + "static/alphabet-50f39c5000c3283e948a10c49dcb8969.png";